import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('lad-mock').component('ladMockByProvider', {
        bindings: {
            providerEid: '<',
            ladList: '<',
            fileClick: '='
        },
        controller: LadMockByProviderController,
        templateUrl: require('./lad-mock-byprovider.html')
    });

    LadMockByProviderController.$inject = ['LadProviderService'];

    function LadMockByProviderController(LadProviderService) {
        var ctrl = this;
        var providerMap = {};
        ctrl.getProviderName = getProviderName;

        ctrl.$onInit = function() {
            LadProviderService.findAll().$promise.then(function(providers) {
                _.forEach(providers, function(data) {
                    providerMap[data.eId] = data.name;
                });
            });

            var groupedByPcp = _.groupBy(ctrl.ladList, function(data) {
                return data.principalDesc;
            });

            // On tri selon le nom du DO qui se trouve dans la concatenantion du non et de l'eid.
            var keys = _.sortBy(_.keys(groupedByPcp), function(key) {
                return key.split(' - ')[1];
            });

            // On crée un objet à partir d'un tableau obtenu en faisant un _.map
            // des clés qu'on avait ordoné et du regroupement qu'on avait fait plus haut.
            ctrl.ladByPrincipal = _.fromPairs(_.map(keys, key => [key, groupedByPcp[key]]));
        };

        /**
         * Fournit le nom du provider.
         */
        function getProviderName() {
            return providerMap[ctrl.providerEid];
        }
    }
})();
